import state from './moduleQuizState'
import mutations from './moduleQuizMutations'
import actions from './moduleQuizActions'
import getters from './moduleQuizGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
